const stringifyErrorDetail = (detail) => {
  if (typeof detail === "string") return detail;
  if (typeof detail === "number" || typeof detail === "boolean") {
    return String(detail);
  }
  if (Array.isArray(detail)) {
    const messages = detail.map(stringifyErrorDetail).filter(Boolean);
    return messages.length ? messages.join("; ") : null;
  }
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string") return detail.message;
    if (typeof detail.msg === "string") return detail.msg;
  }
  return null;
};

export const getApiErrorMessage = (error, fallback) => {
  const responseData = error?.response?.data;
  return (
    stringifyErrorDetail(responseData?.detail) ||
    stringifyErrorDetail(responseData?.message) ||
    stringifyErrorDetail(error?.message) ||
    fallback
  );
};

